/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    arrayOf, func, number, object, shape, string, array,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import subscriptionConfig from '../../../../../helpers/common/subscription/subscription-helpers';
import EventDispatcher from '../../../state/reducers/EventDispatcher';

const styles = () => ({
    frequencyWrapper: {
        width: '100%',
        maxWidth: '400px',
        '@media screen and (min-width: 1440px)': {
            display: 'block',
        },
    },
    frequencyButtonContainer: {
        padding: '13px 12px 16px',
        border: '1px solid #dcdcdc',
        borderRadius: '3px',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        color: '#000',
        cursor: 'pointer',
    },
    cancelledStatus: {
        cursor: 'auto',
    },
    frequencyButton: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        transition: '.3s',
        transform: 'rotate(90deg)',
    },
    listContainer: {
        marginTop: '9px',
        boxShadow: '0 3px 3px rgba(47, 47, 47, 0.15)',
        background: '#FFFFFF',
    },
    frequencySelect: {
        backgroundColor: '#fff',
        display: 'flex',
    },
    frequencyList: {
        cursor: 'pointer',
        padding: '8px 10px 8px 22px',
        '&:hover': {
            backgroundColor: '#fff',
        },
    },
    frequencyLabel: {
        padding: '8px 0',
        '@media screen and (min-width: 1024px)': {
            padding: '16px 0',
        },
    },
    subscriptionContent: {
        marginBottom: 9,
        '@media screen and (max-width: 1025px)': {
            marginBottom: 0,
        },
    },
    durationContainer: {
        marginTop: '0',
    },
    frequencyContainer: {
        width: '100%',
    },
    dropDownContainer: {
        width: '100%',
    },
});

const SubscriptionDropDown = ({
    classes,
    fieldLabel,
    brandColor,
    subscription,
    subscriptionsList,
    setFrequencyValue,
    setDurationValue,
    subscriptions,
    enableEditButton,
}) => {
    const dispatch = useDispatch();
    const [openFrequencyList, setOpenFrequencyList] = React.useState(false);
    const [openDurationList, setOpenDurationList] = React.useState(false);
    const [subFrequency, setSubFrequency] = React.useState({});
    const [subDuration, setSubDuration] = React.useState({});

    const handleFrequencyDropDown = () => {
        setOpenFrequencyList(!openFrequencyList);
        setOpenDurationList(false);
    };
    // const handleDurationDropDown = () => {
    //     setOpenDurationList(!openDurationList);
    //     setOpenFrequencyList(false);
    // };

    const frequencyDropdownList = Object.keys(subscriptionConfig?.['subscription_interval']).map((item) => {
        const obj = {
            id: Number(item),
            value: subscriptionConfig?.['subscription_interval'][item],
        };
        return obj;
    });
    const durationDropdownList = Object.keys(subscriptionConfig?.['subscription_duration']).map((item) => {
        const obj = {
            id: Number(item),
            value: subscriptionConfig?.['subscription_duration'][item],
        };
        return obj;
    });

    useEffect(() => {
        // set default value
        setSubFrequency(frequencyDropdownList.find((item) => subscription?.['interval'] === item?.id));
        setSubDuration(durationDropdownList.find((item) => subscription?.['duration'] === item?.id));
    }, [subscriptionsList, subscription]);

    const frequencyOptionList = frequencyDropdownList.filter((item) => subscriptionsList?.['interval']?.includes?.(item?.id));
    // const durationOptionList = durationDropdownList.filter((item) => subscriptionsList?.['duration']?.includes?.(item?.id));

    const handleFrequencyChange = (frequency) => {
        setFrequencyValue(frequency?.id);
        setSubFrequency(frequency);
        const frequencyData = {
            ruleId: subscription.ruleId,
            frequency: frequency?.id,
        };
        const updatedSubscriptions = [...subscriptions];
        const index = updatedSubscriptions.findIndex((sub) => sub.ruleId === subscription.ruleId);
        if (index > -1) {
            updatedSubscriptions[index].interval = frequency?.id;
            dispatch(EventDispatcher.updateSubscriptionList(updatedSubscriptions));
        }
        dispatch(EventDispatcher.updateSubscriptionFrequency(frequencyData));
        setOpenFrequencyList(false);
    };

    const handleDurationChange = (duration) => {
        setDurationValue(duration?.id);
        setSubDuration(duration);
    };

    const PAY_AS_YOU_GO_ORDER = subscription?.subscriptionType?.toLowerCase() === 'monthonly';
    const disableEditBtn = !enableEditButton(subscription) || PAY_AS_YOU_GO_ORDER;

    return (
        <div className={classes.subscriptionContent}>
            <div className={classes.frequencyWrapper}>
                <div className={classes.frequencyContainer}>
                    <div className={classes.frequencyLabel}>
                        {fieldLabel}
                    </div>
                    <div className={classes.dropDownContainer}>
                        <div
                            aria-hidden="true"
                            onClick={!disableEditBtn ? handleFrequencyDropDown : undefined}
                            className={`${classes.frequencyButtonContainer} ${disableEditBtn ? classes.cancelledStatus : ''}`}
                        >
                            <span className={classes.frequencyButton}>{subFrequency?.value}</span>
                            {!disableEditBtn && <ArrowForwardIosIcon className={classes.icon} style={{ color: brandColor || '#201648', transform: openFrequencyList ? 'rotate(270deg)' : '' }} />}
                        </div>
                        {openFrequencyList && (
                            <div className={classes.listContainer}>
                                {frequencyOptionList.map((item) => (
                                    <div
                                        key={item?.id}
                                        aria-hidden="true"
                                        className={`${classes.frequencyList} ${item?.id === subFrequency?.id ? classes.frequencySelect : ''}`}
                                        onClick={() => handleFrequencyChange(item)}
                                    >
                                        {item?.value}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className={classes.durationContainer}>
                    <div className={classes.frequencyLabel}>
                        Duration
                    </div>
                    <div className={classes.dropDownContainer}>
                        <div
                            aria-hidden="true"
                            className={`${classes.frequencyButtonContainer} ${classes.cancelledStatus}`}
                        >
                            <span className={classes.frequencyButton}>{subDuration?.value}</span>
                        </div>
                        {openDurationList && (
                            <div>
                                {durationDropdownList.map((item) => (
                                    <div
                                        key={item?.id}
                                        aria-hidden="true"
                                        className={`${classes.frequencyList} ${item?.id === subDuration?.id ? classes.frequencySelect : ''}`}
                                        onClick={() => handleDurationChange(item)}
                                    >
                                        {item?.value}
                                        {item?.id === subDuration?.id}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

SubscriptionDropDown.propTypes = {
    classes: object.isRequired,
    subscription: object.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }).isRequired,
    fieldLabel: string,
    setFrequencyValue: func,
    setDurationValue: func,
    brandColor: string.isRequired,
    subscriptions: array.isRequired,
    enableEditButton: func.isRequired,
};

SubscriptionDropDown.defaultProps = {
    fieldLabel: 'Frequency:',
    setFrequencyValue: () => {},
    setDurationValue: () => {},
};

export default withStyles(styles)(SubscriptionDropDown);
